<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="image" src="images/logo.jpg"/></p>
<p class="tx2"><span class="small">“GIRL, WHY YOU</span> balled-up in the bedclothes there? Come on out now, or I’ll pull you out myself, like I did yesterday. You didn’t like that, did you?”</p>
<p class="tx">Yesterday? The soldier can’t remember yesterday.</p>
<p class="tx">A wave of cold as the nurse pulls off the sheet. Wet gown bunched and piss-stinky. Back throbbing.</p>
<p class="tx">“Oh, honey. You had a rough night, huh? Come on, up you get and we’ll wash you nice and clean.”</p>
<p class="tx">The nurse wraps her big arms around the soldier and drags her out of the hospital bed, wet and reeking.</p>
<p class="tx">The nurse and the soldier dancing the waltz of shame.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781569479674_Split8.vue?8bdb2b40